import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'

// Legacy redirect — `/admin/organizations` was merged into `/organizations`.
// Preserve any incoming search params (q, status, page, limit, org) so deep
// links keep working for one release.
export const Route = createFileRoute('/admin/organizations/')({
  validateSearch: (search: Record<string, unknown>) => search,
  component: RedirectComponent,
})

function RedirectComponent() {
  const navigate = useNavigate()
  const search = Route.useSearch()

  useEffect(() => {
    navigate({ to: '/organizations', search: search as any, replace: true })
  }, [navigate, search])

  return null
}
